import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Link } from "react-router-dom";
import SearchPage from "../SearchPage/SearchPage";
import { formatImagePath } from "../../helpers/image";

const HeaderMenuCorporatePopup = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [subList, setSubList] = useState([]);

  const handleOpen = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleHover = (imageUrl) => {
    setSubList([]);
    setHoveredImage(imageUrl);
  };

  const handleShowSubList = (list) => {
    setSubList(list);
  };

  const handleMenuItemClick = () => {
    handleClose();
  };

  return (
    <div style={{ display: "flex" }}>
      <img
        src="/img/homepage/nav-hamburger-icon.png"
        alt=""
        onClick={handleOpen}
        style={{
          cursor: "pointer",
          width: "60%",
          height: "100%",
          marginLeft: "10px",
        }}
      />
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        className={`headermenu-popup-secion ${dialogOpen ? "open" : ""} ${
          dialogOpen ? "dialog-slide-in" : "dialog-slide-out"
        }`}
      >
        <DialogTitle>
          <Link to={"/"} onClick={handleMenuItemClick}>
            <img
              width="200px"
              src="/img/logo/kpj_logo.png"
              alt=""
              loading="lazy"
            />
          </Link>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", top: "8px", right: "8px" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="two-columns-grid">
            <div className="first-coloumn">
              <div className="first-coloumn-sub">
                <Link
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleShowSubList([
                      {
                        label: "Who We Are",
                        link: "https://kpj.listedcompany.com/profile.html",
                      },
                      {
                        label: "Board of Directors",
                        link: "https://kpj.listedcompany.com/directors.html#directors",
                      },
                      {
                        label: "Senior Management Team",
                        link: "https://kpj.listedcompany.com/directors.html#managements",
                      },
                      {
                        label: "Group Corporate Structure",
                        link: "https://kpj.listedcompany.com/directors.html#structure",
                      }
                    ])
                  }
                  onClick={handleMenuItemClick}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                  to="/corporate-home"
                >
                  Corporate Profile
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleShowSubList([
                      {
                        label: "Overview",
                        link: "https://kpj.listedcompany.com/home.html",
                      },
                      {
                        label: "Bursa Announcements",
                        link: "https://kpj.listedcompany.com/newsroom.html",
                      },
                      {
                        label: "Corporate Governance",
                        link: "https://kpj.listedcompany.com/corporate_governance.html",
                      },
                      {
                        label: "Stock Information",
                        link: "https://kpj.listedcompany.com/stock_fundamentals.html",
                      },
                      {
                        label: "Financials Information",
                        link: "https://kpj.listedcompany.com/financials.html",
                      },
                      {
                        label: "Information Request",
                        link: "https://kpj.listedcompany.com/email_alerts.html",
                      }
                    ])
                  }
                  onClick={handleMenuItemClick}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                  to="https://kpj.listedcompany.com/home.html"
                >
                  Investor Relations
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleShowSubList([
                      {
                        label: "Our Sustainability Reporting",
                        link: "https://kpj.listedcompany.com/sustainability.html",
                      },
                    ])
                  }
                  onClick={handleMenuItemClick}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                  to="https://kpj.listedcompany.com/sustainability.html"
                >
                  Sustainability
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleShowSubList([
                      {
                        label: "CSR Initiatives",
                        link: "/csr",
                      },
                      {
                        label: "Klinik Waqaf An-Nur",
                        link: "/klinik-wakaf-an-nur",
                      },
                    ])
                  }
                  onClick={handleMenuItemClick}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                  to="/csr"
                >
                  Corporate Responsibility
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  to="/news"
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleHover("./../img/header/news.png")
                  }
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  News
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  to="/career"
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleHover("./../img/header/career.png")
                  }
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  Careers
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  to="/procurement"
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleHover("./../img/header/tender.png")
                  }
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  Procurement
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  to="/innovationcampaign"
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleHover("./../img/header/kraft.jpg")
                  }
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  K.R.A.F.T. Challenge
                </Link>
              </div>
              <div className="first-coloumn-sub">
                <Link
                  to="https://kpjhealthsystem.com.my/"
                  className="hover-trigger"
                  onMouseEnter={() =>
                    handleHover("./../img/header/health-system.jpg")
                  }
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  KPJ Health System
                </Link>
              </div>
            </div>
            <div
              className="second-coloumn"
              style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignContent: "space-around",
              }}
            >
              <div className="second-coloumn-sub">
                <Link
                  to="/corporate-home"
                  onClick={handleClose}
                  style={{
                    fontSize: "35px",
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  Home
                </Link>
              </div>
              {subList && subList.length > 0 ? (
                subList.map((item, index) => (
                  item.link.startsWith('https') ? (
                    <a
                      key={index}
                      href={item.link}
                      rel="noopener noreferrer"
                      style={{
                        fontSize: "25px",
                        fontWeight: "500",
                        color: "#3A3A3A",
                        marginTop: index === 0 ? "30px" : "0px",
                        textDecoration: 'none' // Ensure the text looks like a link
                      }}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      key={index}
                      to={item.link}
                      onClick={handleClose}
                      style={{
                        fontSize: "25px",
                        fontWeight: "500",
                        color: "#3A3A3A",
                        marginTop: index === 0 ? "30px" : "0px"
                      }}
                    >
                      {item.label}
                    </Link>
                  )
                ))
              ) : (
                <div
                  className="image-container"
                  style={{
                    marginTop: "20px",
                    width: "500px",
                    height: "350px",
                    backgroundImage: `url(${formatImagePath(hoveredImage)})`,
                    backgroundSize: "100%",
                    backgroundRepeat: "no-repeat",
                    transition: "background-image 0.3s ease-in-out",
                  }}
                />
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6">
              <ul>
                <li>
                  <a href="https://www.facebook.com/KPJHealthcareOfficial">
                    <i
                      className="fab fa-facebook-f"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/kpjhealthcareberhadofficial/">
                    <i
                      className="fab fa-instagram"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com">
                    <i
                      className="fab fa-twitter"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/kpj-healthcare-bhd/">
                    <i
                      className="fab fa-linkedin"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@kpjhealthcaretv">
                    <i
                      className="fab fa-youtube"
                      style={{ fontSize: "24px" }}
                    ></i>
                  </a>
                </li>
              </ul>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-6"
              style={{ display: "none" }}
            >
              <Link to="/search">
                <SearchPage />
              </Link>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HeaderMenuCorporatePopup;
